import request from '@/utils/request'
import { AxiosPromise } from 'axios'
export function getCategories(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/categories',
    method: 'get',
    params: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function recommendations(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/recommendations',
    method: 'get',
    params: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function gettagMaterials(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/tagMaterials',
    method: 'get',
    params: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}







export function getmaterials(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials',
    method: 'get',
    params: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function uploadMaterials(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design-engine/materials/upload',
    method: 'post',
    data: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function createDesign(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/resource',
    method: 'post',
    data: data,
    baseURL: 'https://engine.aishanyin.com'
  })
}


export function getCanvasDpi(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/getCanvasDpi',
    method: 'post',
    data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function saveCanvasDpi(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/design/saveCanvasDpi',
    method: 'post',
    data,
    baseURL: 'https://engine.aishanyin.com'
  })
}
export function authUser(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/auth/user',
    method: 'post',
    data,
    baseURL: 'https://engine.aishanyin.com'
  })
}



export function makeCustomizedImages(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/makeCustomizedImages',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}

export function makeImgIng(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: 'api/makeImgIng',
    method: 'post',
    data: data,
    baseURL: 'https://www.aishanyin.com'
  })
}
export function getOrderInfo(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: 'api/getOrderInfo',
    method: 'get',
    params: data,
    baseURL: 'https://www.aishanyin.com'
  })
}
export function getCanvasJson(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/getCanvasJson',
    method: 'post',
    data: data,
    baseURL: 'https://www.aishanyin.com'
  })
}

export function saveCanvasData(data: Record<string, any>): AxiosPromise<any> {
  return request({
    url: '/api/saveCanvasData',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}